/**
 * Invalidate every query that reflects business figures derived from jobs,
 * line items and payments. Job create/update/delete and line-item changes all
 * feed the same KPI tiles, charts, sales summary, cash flow and client
 * dashboards — invalidating them together keeps those numbers in sync instead
 * of going stale until a manual refresh.
 *
 * Single-element keys match by prefix, so ['sales'] covers ['sales','summary']
 * and ['sales','paginated'], and ['client-stats'] covers every ['client-stats', id].
 */
export const invalidateJobStats = (queryClient) => {
    [
        'jobs',                 // job lists + ['jobs','details', id]
        'sales',                // ['sales','summary'] + ['sales','paginated']
        'sales-trend',          // sales revenue trend chart
        'overview-totals',      // KPI tiles (completed, paid vs unpaid, revenue)
        'overview-dashboard',   // all Overview cards and attention/job lists
        'overview-sales',       // top services by revenue
        'overview-deliveries',  // driver deliveries chart
        'client-stats',         // client dashboard KPIs (every client)
        'calendar-data',        // calendar view
        'cash-flow',            // cash-flow figures
        'job-reports',          // job reports
        'jobs-performance',     // jobs performance report
    ].forEach((key) => queryClient.invalidateQueries([key]));
};
